import React from 'react'
import { Link } from 'react-router-dom'
import { FaLeaf, FaFacebook, FaTwitter, FaInstagram, FaYoutube, FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa'
import logo from '/src/assets/logo.png'

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-green-900 to-green-800 text-white mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src={logo} alt="Ayurchikitsak" className="h-10 w-auto rounded-3xl" />
              <span className="text-xl font-ayurvedic font-bold">Ayurchikitsak</span>
            </div>
            <p className="text-green-100 mb-4">
              Experience the healing power of Ayurveda with our expert practitioners and natural treatments.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/Dr.Chidanand.G.Patwardhan" className="text-green-300 hover:text-white transition-colors">
                <FaFacebook size={20} />
              </a>
              <a href="#" className="text-green-300 hover:text-white transition-colors">
                <FaTwitter size={20} />
              </a>
              <a href="https://www.instagram.com/dr.chidanand.patwardhan?igsh=MXV3MDhvamhwcGRhcg==" className="text-green-300 hover:text-white transition-colors">
                <FaInstagram size={20} />
              </a>
              <a href="https://youtu.be/Ng6zHBwPDDA?si=xq-wTrVYhqTs_2gD" className="text-green-300 hover:text-white transition-colors">
                <FaYoutube size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-green-100 hover:text-white transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/live-status" className="text-green-100 hover:text-white transition-colors">Live Status</Link>
              </li>
              <li>
                <Link to="/booking" className="text-green-100 hover:text-white transition-colors">Book Online</Link>
              </li>
              <li>
                <Link to="/admin/login" className="text-green-100 hover:text-white transition-colors">Admin</Link>
              </li>
            </ul>
          </div>

          {/* Clinic Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Clinic Hours</h3>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2 text-green-100">
                <FaClock className="text-secondary-300" />
                <span>Morning: 10:00 AM - 12:30 PM</span>
              </li>
              <li className="flex items-center space-x-2 text-green-100">
                <FaClock className="text-secondary-300" />
                <span>Evening: 5:00 PM - 8:30 PM</span>
              </li>
              <li className="flex items-center space-x-2 text-green-100">
                <FaClock className="text-secondary-300" />
                <span>Sunday: 10:00 AM - 12:30 PM</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-green-100">
                <FaMapMarkerAlt className="text-secondary-300 mt-1" />
                <span>637V+XGW, Tilak Nagar, Dombivli East, Dombivli, Maharashtra 421201, India</span>
              </li>
              <li className="flex items-center space-x-2 text-green-100">
                <FaPhone className="text-secondary-300" />
                <span>+91 88503 25369</span>
              </li>
              <li className="flex items-center space-x-2 text-green-100">
                <FaEnvelope className="text-secondary-300" />
                <span>ayurchikitsak05@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-green-700 mt-8 pt-8 text-center text-green-200">
          <p>&copy; {new Date().getFullYear()} Ayurchikitsak Ayurvedic Clinic. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer